export default __webpack_public_path__ + "static/media/volunteers.7f4ef87a.jpg";